import React, { useCallback, useEffect, useState } from 'react';
import PlanningAtelier from '../PlanningAtelier';
import PlanningMobile from './PlanningMobile';

// ═══════════════════════════════════════════════════════════════════════════
// Aiguillage du Planning selon l'écran (2026-10-23, demande utilisateur).
//
// Sur téléphone, la grille par mécanicien est inutilisable : 9 à 26 colonnes
// d'au moins 150 px, glisser-déposer, clic droit. Le téléphone reçoit donc une
// AUTRE page (liste par atelier + recherche + dossier en une colonne), et la
// version ordinateur n'est pas touchée : `PlanningAtelier` est rendu tel quel.
//
// Seuil : < 768 px de large, ou un écran tactile de moins de 500 px de haut
// (un téléphone tourné en paysage dépasse 768 px de large : sans ce second
// critère, la grille reviendrait au milieu d'une consultation). Un iPad en
// portrait (768 px) garde la grille.
//
// « Version ordinateur » est un choix PAR APPAREIL (localStorage) : celui qui
// préfère la grille sur son téléphone la retrouve à chaque visite, et un bouton
// flottant lui rend la version téléphone.
// ═══════════════════════════════════════════════════════════════════════════

const REQUETE_TELEPHONE = '(max-width: 767px), (pointer: coarse) and (max-height: 500px)';
const CLE_FORCE_ORDINATEUR = 'planning-version-ordinateur';

const lireForce = () => {
  try { return localStorage.getItem(CLE_FORCE_ORDINATEUR) === '1'; } catch (e) { return false; }
};

export default function PlanningSelonEcran(props) {
  const [telephone, setTelephone] = useState(
    () => typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(REQUETE_TELEPHONE).matches
  );
  const [forceOrdinateur, setForceOrdinateur] = useState(lireForce);

  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const mq = window.matchMedia(REQUETE_TELEPHONE);
    const suivre = (e) => setTelephone(e.matches);
    mq.addEventListener('change', suivre);
    return () => mq.removeEventListener('change', suivre);
  }, []);

  // Le dossier ouvert sur le téléphone est rouvert dans la grille par le lien
  // profond qui sert déjà à Gestion Parking (`planning-open-intervention`).
  const versionOrdinateur = useCallback((idDossier) => {
    try {
      if (idDossier) sessionStorage.setItem('planning-open-intervention', String(idDossier));
      localStorage.setItem(CLE_FORCE_ORDINATEUR, '1');
    } catch (e) { /* stockage indisponible : la bascule vaut pour cette visite */ }
    setForceOrdinateur(true);
  }, []);

  const versionTelephone = useCallback(() => {
    try { localStorage.removeItem(CLE_FORCE_ORDINATEUR); } catch (e) { /* idem */ }
    setForceOrdinateur(false);
  }, []);

  if (telephone && !forceOrdinateur) {
    return <PlanningMobile {...props} onVersionOrdinateur={versionOrdinateur} />;
  }
  return (
    <>
      <PlanningAtelier {...props} />
      {telephone && (
        <button type="button" className="pm-retour-telephone" onClick={versionTelephone}>
          Version téléphone
        </button>
      )}
    </>
  );
}
